import { SvgImageName } from './types';
import { SvgSpriteIcon, SvgSpriteIconProps } from './SvgSpriteIcon';

const SVG_IMAGE_SIZE: Record<SvgImageName, { width: number; height: number }> =
  {
    [SvgImageName.ARDOQ_LOGO]: { width: 64, height: 64 },
    [SvgImageName.ARDOQ_LOGO_WITH_NAME]: { width: 710, height: 181 },
    [SvgImageName.ARDOQ_LOGO_MONO_WITH_NAME]: { width: 710, height: 181 },
    // [SvgImageName.ARDOQ_DISCOVER_LOGO_WITH_NAME]: { width: 689, height: 33 },
    [SvgImageName.ARDOQ_DISCOVER_LOGO_WITH_NAME]: { width: 1495, height: 180 },
    [SvgImageName.BOTTOM_RIGHT_CORNER_FRAME]: { width: 242, height: 153 },
    [SvgImageName.INVERTED_ARDOQ_LOGO]: { width: 64, height: 64 },
    [SvgImageName.SIMPLE_BLOCK_DIAGRAM]: { width: 200, height: 100 },
    [SvgImageName.BLOCKS]: { width: 200, height: 100 },
    [SvgImageName.TIMELINE]: { width: 200, height: 100 },
    [SvgImageName.NETWORK]: { width: 200, height: 100 },
    [SvgImageName.DEPENDENCY_MAP]: { width: 200, height: 100 },
    [SvgImageName.BUBBLE]: { width: 200, height: 100 },
    [SvgImageName.COMPONENT_MATRIX]: { width: 200, height: 100 },
  };

const ARIA_LABEL_MAP: Record<SvgImageName, string> = {
  [SvgImageName.ARDOQ_DISCOVER_LOGO_WITH_NAME]: 'Ardoq Discover Logo',
  [SvgImageName.BLOCKS]: 'Interactive Blocks',
  [SvgImageName.BUBBLE]: 'Bubblechart',
  [SvgImageName.DEPENDENCY_MAP]: 'Dependency Map',
  [SvgImageName.INVERTED_ARDOQ_LOGO]: 'Ardoq Logo',
  [SvgImageName.ARDOQ_LOGO]: 'Ardoq Logo',
  [SvgImageName.ARDOQ_LOGO_WITH_NAME]: 'Ardoq Logo',
  [SvgImageName.ARDOQ_LOGO_MONO_WITH_NAME]: 'Ardoq Logo',
  [SvgImageName.BOTTOM_RIGHT_CORNER_FRAME]: 'Bottom right corner frame',
  [SvgImageName.SIMPLE_BLOCK_DIAGRAM]: 'Simple block diagram',
  [SvgImageName.TIMELINE]: 'Timeline',
  [SvgImageName.NETWORK]: 'Network',
  [SvgImageName.COMPONENT_MATRIX]: 'Component Matrix',
};

export type SvgImageProps = Omit<SvgSpriteIconProps, 'symbolName'> & {
  svgImageName: SvgImageName;
  role?: React.AriaRole;
};

export const SvgImage = ({ svgImageName, ...rest }: SvgImageProps) => (
  <SvgSpriteIcon
    symbolName={svgImageName}
    width={SVG_IMAGE_SIZE[svgImageName].width}
    height={SVG_IMAGE_SIZE[svgImageName].height}
    aria-label={ARIA_LABEL_MAP[svgImageName]}
    {...rest}
  />
);
